import { useCallback, useEffect, useState } from 'react';
import { LoadingSpin, PageContainer } from '@/components';
import { useParams } from 'react-router-dom';
import { SurveyHttp } from '@/services';
import SurveyParticipate from '@/components/survey/SurveyParticipate';
import SurveyFaceAuth from './SurveyFaceAuth';

export function SurveyParticipatePage() {

  const { surveyId = null } = useParams();
  const [survey, setSurvey] = useState<SurveyEntity>(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  console.log('surveyId', surveyId);

  const fetchSurvey = useCallback(async () => {
    if (!surveyId) return;
    setLoading(true);
    try {
      const sur = await SurveyHttp.findSurveyById(Number(surveyId));
      setSurvey(sur);
    }
    finally {
      setLoading(false);
    }
  }, [surveyId]);

  useEffect(() => {
    fetchSurvey();
  }, [fetchSurvey]);

  if (loading) {
    return <LoadingSpin fillHeight />;
  }

  return (
    <PageContainer title={survey?.name}>
      {!showForm && survey.facialRecognition ?
        <SurveyFaceAuth survey={survey} onComplete={() => setShowForm(true)} /> :
        <SurveyParticipate survey={survey} />
      }
    </PageContainer>
  );
}

export default SurveyParticipatePage;
